<!--
__________________________________________________
Summary 
‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾
Vue component for displaying new app version status message.

This is separate from the status component, because although it uses the same bootstrap functionality,
it should be continuously displayed (and not closed with other status messages) until the page is refreshed. 

Usage: Just drop this component in a top level component.

-->
<template>
  <transition :duration="{ enter: 400, leave: 300 }" name="slide-fade">
    <div v-show="show" 
      class="alert fade new-version-status-container alert-warning" 
    >
      <span v-show="false" class="glyphicons glyphicons-ok-circle mr-2" style="margin-left:-18px;"></span>
      <span  class="font-weight-semibold">New Archiver Version</span>
      <br>
      <span class="font-normal">A new version of Archiver is available. <a href="#" @click="refresh()" class="alert-link">Please click here to refresh the page.</a></span>
    </div>
  </transition>    
</template>

<script>
import {mapState} from 'vuex'

export default {
 data: function(){return{
    previousAppVersion: null,
    checkInterval: 1000 * 60 * 15, //every 15 minutes
    show: false,
  }},  

  methods: {
    refresh(){
      location.reload();
    },
    //returns true if there's a new version.  False if there was no prior version (ie first time fetching)
    async checkForNewVersion(){
      let response = await fetch("/");
      let text = await response.text();
      if (this.previousAppVersion){
        if (text != this.previousAppVersion){
          return true;
        }
      } else {
        this.previousAppVersion = text;
      }
      return false;
    },
    showNewVersionMessage(){
      this.show = true;
    },
  },
  mounted: function(){
    let that = this;
    //check for new version first (to get the initial version)
    //and then setup an interval
    this.checkForNewVersion()
    .then(result=>{
      let timer = setInterval( async function(){
        let newVersion = await that.checkForNewVersion();
        if (newVersion){
          console.log("New App Version Available");
          that.showNewVersionMessage();
          //no need to check anymore
          clearInterval(timer);
        } 
      },this.checkInterval ); 
    })
  }

}
</script>

<style>

  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.1, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(50px);
    opacity: 0;
  }

.new-version-status-container {
  right: 0%;
  bottom: 0%;
  opacity: 1;
  padding: 10px;
  margin-right:20px;
  position: absolute;
  width: 500px;
  z-index: 6000;
}  

</style>